import { useCallback } from "react";

import type { PaymentDepositAccountInput } from "@/lib/gql/__generated__/graphql";

import * as MutationRepository from "@/components/features/settings/payment-deposit-account/repository/mutation";

import type { PaymentDepositAccountFormModel } from "../type";

type Props = {
	viewModel: PaymentDepositAccountFormModel["ViewModel"];
};

export const useUpdatePaymentDepositAccount = ({ viewModel }: Props) => {
	const { onUpdatePaymentDepositAccount: _onUpdatePaymentDepositAccount } =
		MutationRepository.usePaymentDepositAccountMutation();
	const onUpdatePaymentDepositAccount = useCallback(async () => {
		const input: PaymentDepositAccountInput = {
			bankAccountHolderName: viewModel.bankAccountHolderName.value,
			bankAccountNumber: viewModel.bankAccountNumber.value,
			bankAccountType: viewModel.bankAccountType.value,
			bankBranchCode: viewModel.bankBranchCode.value,
			bankCode: viewModel.bankCode.value,
			hotelID: viewModel.hotelID,
			minimumTransferAmount: viewModel.minimumTransferAmount.value,
		} satisfies PaymentDepositAccountInput;
		return await _onUpdatePaymentDepositAccount(input);
	}, [
		_onUpdatePaymentDepositAccount,
		viewModel.bankAccountHolderName.value,
		viewModel.bankAccountNumber.value,
		viewModel.bankAccountType.value,
		viewModel.bankBranchCode.value,
		viewModel.bankCode.value,
		viewModel.hotelID,
		viewModel.minimumTransferAmount.value,
	]);

	return {
		onUpdatePaymentDepositAccount,
	};
};
